import moment from 'moment'
import {
  SORT_ORDER_APPOINTMENT_DATETIME, DIRECTION_ASC, DATE_ATTR_APPT_TIME, TODAY, ALL
} from '../constants/search_filters'

import { NOTIFICATION_STATUS_CHANGE, PRICE_REVIEW, AWAITING_APPROVAL } from '../constants/orders'

export function isProhibitedNotification(notification) {
  return notification.type === NOTIFICATION_STATUS_CHANGE &&
    ![PRICE_REVIEW, AWAITING_APPROVAL].includes(notification.notification_to_status)
}

export function defaultFilters() {
  return {
    sort_attr: SORT_ORDER_APPOINTMENT_DATETIME,
    sort_direction: DIRECTION_ASC,
    start_date: moment(),
    end_date: moment(),
    date_type: TODAY,
    exclude_tbc: true,
    date_attr: DATE_ATTR_APPT_TIME,
    order_scopes: [ALL]
  }
}
